import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeminiCli = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M44.1459 0H9.85403C4.4118 0 0 4.4118 0 9.85403V44.1459C0 49.5882 4.4118 54 9.85403 54H44.1459C49.5882 54 54 49.5882 54 44.1459V9.85403C54 4.4118 49.5882 0 44.1459 0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.1459 0H9.85403C4.4118 0 0 4.4118 0 9.85403V44.1459C0 49.5882 4.4118 54 9.85403 54H44.1459C49.5882 54 54 49.5882 54 44.1459V9.85403C54 4.4118 49.5882 0 44.1459 0Z",
			fill: "#1E1E2E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.2733 0.000823972C49.6568 0.069039 54 4.45428 54 9.8539V44.1463L53.9992 44.2733C53.9308 49.6568 49.5458 54 44.1463 54H9.8539C4.41176 54 5.54491e-05 49.588 0 44.1463V9.8539C5.51863e-05 4.45428 4.34312 0.0690394 9.72662 0.000823972L9.8539 0H44.1463L44.2733 0.000823972ZM9.8539 3.15335C6.1533 3.15341 3.15341 6.1533 3.15335 9.8539V44.1463C3.15341 47.8465 6.1533 50.8465 9.8539 50.8465H44.1463C47.8465 50.8465 50.8465 47.8465 50.8465 44.1463V9.8539C50.8465 6.1533 47.8465 3.15341 44.1463 3.15335H9.8539ZM37.75 23.5331V31.775L16.3217 42.0767V36.1016L33.8765 27.6538L16.3217 19.2065V13.2314L37.75 23.5331Z",
			fill: "url(#paint0_linear_117153_269)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.2733 0.000823972C49.6568 0.069039 54 4.45428 54 9.8539V44.1463L53.9992 44.2733C53.9308 49.6568 49.5458 54 44.1463 54H9.8539C4.41176 54 5.54491e-05 49.588 0 44.1463V9.8539C5.51863e-05 4.45428 4.34312 0.0690394 9.72662 0.000823972L9.8539 0H44.1463L44.2733 0.000823972ZM9.8539 3.15335C6.1533 3.15341 3.15341 6.1533 3.15335 9.8539V44.1463C3.15341 47.8465 6.1533 50.8465 9.8539 50.8465H44.1463C47.8465 50.8465 50.8465 47.8465 50.8465 44.1463V9.8539C50.8465 6.1533 47.8465 3.15341 44.1463 3.15335H9.8539ZM37.75 23.5331V31.775L16.3217 42.0767V36.1016L33.8765 27.6538L16.3217 19.2065V13.2314L37.75 23.5331Z",
			fill: "url(#paint1_linear_117153_269)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_117153_269",
			x1: 12.6131,
			y1: 27.1971,
			x2: 41.4854,
			y2: 27.1971,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .0196292,
					stopColor: "#406AFB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .226827,
					stopColor: "#078EFB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .418757,
					stopColor: "#939AFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .584515,
					stopColor: "#D698FC"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .774264,
					stopColor: "#FA6178"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .97928,
					stopColor: "#F2554F"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_117153_269",
			x1: 0,
			y1: 27.1971,
			x2: 54,
			y2: 27.1971,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#217BFE" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .335283,
					stopColor: "#078EFB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#AC87EB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EE4D5D"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgGeminiCli);
export { ForwardRef as ReactComponent };
